import { useTranslation } from "react-i18next";
import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { MILESTONE_DOT_SIZE, MilestoneItem } from "./MilestoneItem";
import type { Milestone } from "./types";

type Props = {
	milestones: Milestone[];
};

export const MilestonesTimeline = ({ milestones }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box gap={16}>
			<Text variant="titleMedium">{t("lessons.stats.milestones.title")}</Text>
			<FlatCard style={{ borderRadius: theme.roundness * 2 }}>
				<Card.Content
					style={{ paddingLeft: 16, paddingRight: 16, paddingVertical: 16 }}
				>
					<Box position="relative" gap={32}>
						<Box
							position="absolute"
							top={MILESTONE_DOT_SIZE / 2}
							bottom={MILESTONE_DOT_SIZE / 2}
							left={MILESTONE_DOT_SIZE / 2 - 0.5}
							width={1}
							backgroundColor={theme.colors.outlineVariant}
						/>
						{milestones.map((milestone) => (
							<MilestoneItem key={milestone.id} milestone={milestone} />
						))}
					</Box>
				</Card.Content>
			</FlatCard>
		</Box>
	);
};
